import * as React from "react";
import { IBasket } from "../models/IBasket.model";
import BasketContext from "../services/BasketContext";
import BasketService from "../services/BasketService";
import Logger from "../../../gulp/scripts/typescript/modules/Logger";

function DiscountForm(props: IBasket) {

	const [isOpen, setIsOpen] = React.useState(false);
	const [isLoading, setIsLoading] = React.useState(false);
	const [errorMessage, setErrorMessage] = React.useState("");
	const [promotionCode, setPromotionCode] = React.useState(props.PromotionCodes[0]);
	const basketContext = React.useContext(BasketContext);
	const basketService = new BasketService();

	function handleFormSubmit(e: React.FormEvent) {
		if(props.PromotionCodes.length) { // remove
			removeDiscount();
		} else { // add
			if(!promotionCode) {
				setErrorMessage("Please enter a valid discount code");
			} else {
				addDiscount();
			}
		}
		e.preventDefault();
	}

	function removeDiscount() {
		setIsLoading(true);
		basketService.removeDiscount(promotionCode)
		.then((data)=> {
			basketContext.setBasket(data._embedded.basket);
			setPromotionCode("");
			setIsLoading(false);
		})
		.catch((error: Error)=> {
			setErrorMessage('An error has occurred trying to remove the discount code. Please try again.');
			setIsLoading(false);
			Logger.trackException(error, 'Unknown error on remove discount endpoint');
		});
	}

	function addDiscount() {
		setErrorMessage("");
		setIsLoading(true);
		basketService.addDiscount(promotionCode)
		.then((data)=> {
			basketContext.setBasket(data._embedded.basket);
			setPromotionCode(data._embedded.basket.PromotionCodes[0]);
			setIsLoading(false);
		})
		.catch((error: Error)=> {;
			setErrorMessage("Please enter a valid discount code");
			setIsLoading(false);
			Logger.trackException(error, 'Unknown error on add discount endpoint');
		});
	}

	function handleToggleVisibility(e: React.MouseEvent) {
		setIsOpen(!isOpen);
	}

	return (
		<div className={`c-basket__sidebar-item`}>
			<button type="button" onClick={(e) => handleToggleVisibility(e)} className="c-basket__discount-label h2 c-accordion__title c-accordion__title--small" aria-controls="discount-container" aria-expanded={isOpen ? 'true' : 'false'} data-test="basket-discount-code-accordion">
				Add Discount Code
			</button>
			<div className={`c-accordion__content ${isOpen ? 'is-open' : ''}`} id="discount-container">
				<form onSubmit={(e) => handleFormSubmit(e)} noValidate>
						<label htmlFor="PromotionCode" className="u-visuallyhidden">Add Discount Code</label>
						<div className="c-basket__discount-input-wrapper">
							{
								props.PromotionCodes.length ?
								<React.Fragment>
										<input autoComplete="off" className="c-basket__discount-input" data-test="basket-promotion-code-input" disabled id="PromotionCode" name="PromotionCode" required type="text"
										value={promotionCode} onChange={(e)=> setPromotionCode(e.target.value)} />
										<button type="submit" className="c-button c-button--secondary c-basket__discount-button" data-test="basket-discount-button" value="Remove">
											Remove
											{isLoading ?
												<span className="c-loader c-loader--inline"></span>
											: null}
										</button>
								</React.Fragment>
								:
								<React.Fragment>
										<input autoComplete="off" className="c-basket__discount-input" data-test="basket-promotion-code-input" data-val="true" id="PromotionCode" name="PromotionCode" required type="text"
										value={promotionCode} onChange={(e)=> setPromotionCode(e.target.value)} />
										<button type="submit" className="c-button c-button--secondary c-basket__discount-button" data-test="basket-discount-button" value="Apply">
											Apply Discount
											{isLoading ?
												<span className="c-loader c-loader--inline"></span>
											: null}
										</button>
								</React.Fragment>
							}
						</div>
						{errorMessage ?
						<div className="formRow formRow--flush">
							<span className="formError formError--large field-validation-error" data-valmsg-for="PromotionCode" data-valmsg-replace="true"><span data-test="basket-discount-code-validation">{errorMessage}</span></span>
						</div>
						: null}
				</form>
			</div>
		</div>
	);


}

export default DiscountForm;
